// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody } from '@/assets/theme/fonts'

export default function TailoredSection() {
  const { t } = useTranslation('solutionsIotAirQualityMonitoring')

  const items = [
    t('tailored.items.01'),
    t('tailored.items.02'),
    t('tailored.items.03'),
    t('tailored.items.04'),
    t('tailored.items.05'),
    t('tailored.items.06'),
    t('tailored.items.07')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('tailored.eyebrow')}
        title={t('tailored.title')}
        intro={[t('tailored.intro1'), t('tailored.intro2')]}
      />

      <BulletGrid items={items} columns={2} />

      <Typography
        component="p"
        fontSize={getFontBody()}
        sx={{
          marginTop: '2rem',
          paddingLeft: '1rem',
          borderLeft: `3px solid ${themeColors.success.main}`,
          lineHeight: 1.7,
          color: themeColors.gray.defaultText,
          maxWidth: '46rem'
        }}
      >
        {t('tailored.outro')}
      </Typography>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
